var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5124 23.6386V19.4807H12.3624C10.6224 19.4807 9.2124 18.0748 9.2124 16.3399V13.6477C9.2124 11.9128 10.6224 10.5069 12.3624 10.5069H19.5224V6.34903C19.5224 4.96308 21.1824 4.26511 22.1824 5.21235L30.0324 12.7205C31.3224 13.9568 31.3224 16.0109 30.0324 17.2472L22.1824 24.7653C21.1824 25.7325 19.5124 25.0246 19.5124 23.6386Z",
    fill: "#FFB6BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 25.6667C15 26.403 14.3604 27 13.5714 27L4.96191 27C2.51971 27 0.53334 25.157 0.53334 22.8748L0.533341 7.12519C0.533341 4.84298 2.51972 3 4.96191 3L13.5714 3C14.3604 3 15 3.59695 15 4.33333C15 5.06971 14.3604 5.66667 13.5714 5.66667L4.96191 5.66667C4.08982 5.66667 3.39048 6.32306 3.39048 7.12519L3.39048 22.8748C3.39048 23.6769 4.08982 24.3333 4.96191 24.3333L13.5714 24.3333C14.3604 24.3333 15 24.9303 15 25.6667Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogout);
export default __webpack_public_path__ + "static/media/ic_logout.620367db31adfb0faaaf64c73968654f.svg";
export { ForwardRef as ReactComponent };